import React, { ReactNode } from 'react';
import Autosuggest, { InputProps } from 'react-autosuggest';

import { escapeRegexCharacters } from '../../services/utilService';

import './styles.css';

interface IProps {
    getData: Function,
    clearData: Function,
    data: any[],
    updateValue: Function,
    value: string,
    placeholder?: string,
    minLength?: number,
    isLoading?: boolean,
    select?: Function,
    selected?: any,
    validationFunction?: any,
    fieldName?: string,
    showCustomModal?: any,
    createPermission?: boolean
}

const AutoSuggest = (props: IProps) => {
    const {
        value,
        placeholder,
        minLength = 2,
        updateValue,
        data,
        clearData,
        getData,
        isLoading,
        select = () => null,
        selected,
        validationFunction,
        fieldName = 'selectedCustomer',
        showCustomModal,
        createPermission = true
    } = props;

    // When suggestion is clicked, Autosuggest needs to populate the input
    // based on the clicked suggestion. Teach Autosuggest how to calculate the
    // input value for every given suggestion.
    const getSuggestionValue = (suggestion: any) => {
        return suggestion.customerName;
    }

    const onBlur = () => {
        return !value ? validationFunction(fieldName) : '';
    }

    // Use your imagination to render suggestions.
    const renderSuggestion = (suggestion: { customerName: React.ReactNode; }) => {
        return (
            <div>
                {suggestion.customerName}
            </div>
        )
    };

    const onChange = (event: any, { newValue }: any) => {
        updateValue(newValue);
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    const onSuggestionsFetchRequested = ({ value }: { value: string }) => {
        const escapedValue = escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return clearData();
        }
        // clear the seleted customer
        select(null);
        return getData(value);
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    const onSuggestionsClearRequested = () => {
        clearData();
    };

    const shouldRenderSuggestions = (value: string) => {
        return value.trim().length > minLength;
    }

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
        placeholder: placeholder || 'Type Name',
        value,
        onChange: onChange,
        onBlur
    };

    const onSuggestionSelected = (event: any, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }: any) => {
        select(suggestion);
    }

    return <div className='auto-suggest-container'>
        <Autosuggest
            suggestions={data}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
            shouldRenderSuggestions={shouldRenderSuggestions}
            onSuggestionSelected={onSuggestionSelected}
        />
        {createPermission && !selected && value.length > minLength && <button 
            className='btn btn-linkn float-right create-cust-link-btn' 
            onClick={showCustomModal}
        >
            Create New
        </button>}
    </div>
}

export default AutoSuggest;